import * as React from 'react';

import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import PersonIcon from '@mui/icons-material/Person';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import BusinessIcon from '@mui/icons-material/Business';
import Avatar from '@mui/material/Avatar';
import Toolbar from '@mui/material/Toolbar';
import Switch from '@mui/material/Switch';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import ListItemButton from '@mui/material/ListItemButton';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { UserContext, ThemeModes } from './UserProvider';

export default function SettingsMenu() {
   const context = React.useContext(UserContext);
   const [open, setOpen] = React.useState(false);
   const user = context.user;
   const darkMode = context.themeMode === ThemeModes.Dark;

   const onThemeChange = () => {
      context.setThemeMode((darkMode) ? ThemeModes.Light : ThemeModes.Dark);
   };

   const toggleKeyHandler = (open: boolean) => (e: React.KeyboardEvent<HTMLDivElement>) => {
      if (e.type === 'keydown' && (e.key === 'Tab' || e.key === 'Shift')) {
         return;
      }
      setOpen(open);
   };

   const toggleMouseHandler = (open: boolean) => (e: React.MouseEvent<HTMLButtonElement>) => {
      setOpen(open);
   };

   const login = () => {
      context.setLoginStatus(1);
      window.location.href = `api/account/login?context=${window.location.pathname}`;
   };

   const logout = () => {
      context.setLoginStatus(0);
      window.location.href = `api/account/logout?context=${window.location.pathname}`;
   };

   const list = () => (
      <Box
         sx={{ width: 350 }}
         role="presentation"
         onKeyDown={toggleKeyHandler(false)}
      >
         <List subheader={<ListSubheader>{"Account"}</ListSubheader>}>
            <ListItem>
               <ListItemIcon>
                  <PersonIcon />
               </ListItemIcon>
               {(user?.id) ?
                  <ListItemText primary={user?.name} />
                  :
                  <ListItemButton onClick={() => login()}>
                     <ListItemText>{"Login"}</ListItemText>
                  </ListItemButton>
               }
            </ListItem>
            {(user?.id) ?
               <ListItem>
                  <ListItemIcon>
                     <BusinessIcon />
                  </ListItemIcon>
                  <ListItemText primary={user?.companyName} />
               </ListItem> : null
            }
            {(user?.id) ?
               <ListItem>
                  <ListItemIcon>
                     <LogoutIcon />
                  </ListItemIcon>
                  <ListItemButton onClick={() => logout()}>
                     <ListItemText>{"Logout"}</ListItemText>
                  </ListItemButton>
               </ListItem> : null
            }
         </List>
         <List subheader={<ListSubheader>{"Settings"}</ListSubheader>}>
            <ListItem>
               <ListItemIcon>
                  <DarkModeOutlinedIcon />
               </ListItemIcon>
               <ListItemText id="switch-list-label-darkmode" primary={"DarkMode"} />
               <Switch
                  edge="end"
                  onChange={onThemeChange}
                  checked={darkMode}
                  inputProps={{
                     'aria-labelledby': 'switch-list-label-darkmode',
                  }}
               />
            </ListItem>
         </List>
      </Box>
   );

   return (
      <div>
         <Button
            onClick={toggleMouseHandler(true)}
            sx={{ my: 2, display: 'flex', borderRightWidth: '0px', minWidth: '0px' }}
         >
            <Avatar sx={{ height: '24px', width: '24px' }}>
               <PersonIcon />
            </Avatar>
         </Button>
         <Drawer
            anchor={'right'}
            open={open}
            onClose={toggleMouseHandler(false)}
         >
            <Toolbar />
            {list()}
         </Drawer>
      </div>
   );
}
